import { Box, Card, Stack, Text } from '@mantine/core'
import { visitVideoAttachment, type VisitWithRelations } from '@markku/types'
import { Trans } from '@lingui/react/macro'

interface VisitNotesCardProps {
  visit: VisitWithRelations
}

export function VisitNotesCard({ visit }: VisitNotesCardProps) {
  const videoAttachment = visitVideoAttachment(visit)

  if (!visit.notes && !videoAttachment) {
    return null
  }

  return (
    <Card withBorder>
      <Stack gap="md">
        {visit.notes && (
          <Box>
            <Text size="lg" fw={600} mb="xs">
              <Trans>Markku's notes</Trans>
            </Text>
            <Text size="sm" c="dimmed">
              {visit.notes}
            </Text>
          </Box>
        )}

        {videoAttachment?.downloadUrl && (
          <Box>
            <Text size="lg" fw={600} mb="xs">
              <Trans>Video summary</Trans>
            </Text>
            <video
              src={videoAttachment.downloadUrl}
              controls
              style={{
                width: '100%',
                borderRadius: 'var(--mantine-radius-default)',
              }}
            />
          </Box>
        )}
      </Stack>
    </Card>
  )
}
